var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "cell center" }, [
    !!_vm.item.presentAs?.length
      ? _c(
          "div",
          {
            staticClass: "is-flex is-clickable",
            staticStyle: { width: "100%" },
            on: { click: _vm.handlePresentAsClick },
          },
          [
            _vm._l(_vm.item.presentAs, function (split, index) {
              return _c(
                "div",
                {
                  key: split.itemType,
                  staticClass:
                    "pill is-size-7 is-flex is-justify-content-center has-text-light",
                  class: [
                    index > 0
                      ? "has-background-success"
                      : "has-background-primary",
                    { isFirst: index === 0 },
                    { isLast: index === _vm.item.presentAs?.length - 1 },
                  ],
                  style: { width: `${split.percent}%` },
                },
                [_c("span", [_vm._v(_vm._s(split.itemType))])]
              )
            }),
            _c(
              "tippy",
              {
                attrs: {
                  arrow: "",
                  placement: "top",
                  theme: `${_vm.$theme.name}`,
                },
              },
              [
                _c("div", { style: { width: "120px" } }, [
                  _c("div", { staticClass: "mb-4" }, [
                    _c("span", { staticClass: "is-size-6 mb-3" }, [
                      _vm._v("Present As"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "is flex is-flex-row w-100" },
                    _vm._l(_vm.item.presentAs, function (split, index) {
                      return _c(
                        "div",
                        {
                          key: _vm.item.quoteItemId + index,
                          staticClass: "w-100 is-flex is-flex-row mb-2",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-space-between w-100",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pill is-size-7 is-flex is-justify-content-center has-text-light",
                                  class: [
                                    index > 0
                                      ? "has-background-success"
                                      : "has-background-primary",
                                    { isFirst: index === 0 },
                                    {
                                      isFirst:
                                        index ===
                                        _vm.item.presentAs?.length - 1,
                                    },
                                  ],
                                  staticStyle: { width: "50%" },
                                },
                                [
                                  _c("span", [
                                    _vm._v(" " + _vm._s(split.itemType) + " "),
                                  ]),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "pill isLast is-flex is-justify-content-center has-border",
                                  staticStyle: { width: "50%" },
                                },
                                [_vm._v(_vm._s(split.percent) + "%")]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ]
            ),
          ],
          2
        )
      : _c(
          "div",
          {
            staticClass:
              "pill is-size-7 is-flex is-justify-content-center isFirst isLast has-background-grey-light is-clickable",
            style: { width: "100%" },
            on: { click: _vm.handlePresentAsClick },
          },
          [_c("span", [_vm._v("Present As")])]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }